module.exports = __webpack_public_path__ + "static/media/shake_image.c1f52717.png";